import { useNavigate } from "react-router-dom";
import { getAssetUrl } from "../../utils/assetUrl";
import { FISHING_GAME_PROVIDERS } from "./fishingMenuGameProviders";
import BackButton from "../../components/BackButton";
import "../NH/HomeNH.css";

const HomeFishing = () => {
  const navigate = useNavigate();

  const handleClick = (slotLink: string) => {
    navigate(`/fishing/slot${slotLink}`);
  };

  return (
    <div className="nh-hub">
      <div className="container-fluid lobby-bg position-relative mx-auto mb-5 max-w-[1440px]">
        <div className="container mx-auto px-2">
          {/* Header chuẩn Figma Node 1:17470 */}
          <header className="ll-game-hero" aria-label="Bắn cá">
            <BackButton href="/" className="ll-game-hero__back" />
            <h1 className="ll-game-hero__title">HACK BẮN CÁ</h1>
          </header>

          {/* Grid 30 Sảnh Bắn Cá — 6 cột chuẩn Figma Frame 1:17470 */}
          <div className="nh-providers-grid">
            {FISHING_GAME_PROVIDERS.map((e) => (
              <div
                key={e.link}
                className="nh-provider-card"
                onClick={() => handleClick(e.link)}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter" || ev.key === " ") {
                    ev.preventDefault();
                    handleClick(e.link);
                  }
                }}
                role="button"
                tabIndex={0}
              >
                <img
                  className="nh-provider-card__frame"
                  src={getAssetUrl("/assets/llwin/provider-frame.png")}
                  alt=""
                />
                <span className="nh-provider-card__logo">
                  <img src={getAssetUrl(e.url)} alt={e.name} />
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeFishing;

